<template>
  <div class="expert-layout">
    <router-view class="content" />
    <expert-tab-bar />
  </div>
</template>

<script>
import ExpertTabBar from '@/components/ExpertTabBar/index.vue';

export default {
  name: 'ExpertEndLayout',
  components: {
    ExpertTabBar,
  },
};
</script>

<style lang="scss" scoped>
.expert-layout {
  display: flex;
  flex-direction: column;
  height: 100vh;

  .content {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch; // for smooth scrolling on iOS
  }
}
</style>
